//header
import logoHeader from './header/logo-header.png'

//footer
import wechat from './footer/wechat.png'
import weibo from './footer/weibo.png'
import logoFooter from './footer/logo-footer.png'

//home
import carousel1 from './home/carousel-1.png'
import carousel2 from './home/carousel-2.png'

import productBanner1 from './home/product-banner-1.png'
import productBanner2 from './home/product-banner-2.png'

import product1 from './home/product1.png'
import product2 from './home/product2.png'
import product3 from './home/product3.png'
import product4 from './home/product4.png'
import product5 from './home/product5.png'
import inspiration1 from './home/inspiration1.png'
import inspiration2 from './home/inspiration2.png'
import inspiration3 from './home/inspiration3.png'

//series
import seriesBanner from './series/banner.png'
import seriesProduct from './series/product.png'

//product
import productBanner from './product/banner.png'
import miniCode from './product/miniCode.png'
import share from './product/share.png'

export default {
    //header
    logoHeader,

    //footer
    wechat,
    weibo,
    logoFooter,

    //home
    carousel1,
    carousel2,

    productBanner1,
    productBanner2,

    product1,
    product2,
    product3,
    product4,
    product5,

    inspiration1,
    inspiration2,
    inspiration3,

    seriesBanner,
    seriesProduct,

    productBanner,
    miniCode,
    share
}
